import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-min-wage-master',
  templateUrl: './edit-min-wage-master.component.html',
  styleUrls: ['./edit-min-wage-master.component.css']
})
export class EditMinWageMasterComponent {
  @Input() selectedTable2: any;
  @Input() contractorData: any;

  groupedTables: any[] = [];
  selectedDate: Date | null = null;

  constructor(public activeModal: NgbActiveModal) {}

  confirmDate() {
    this.activeModal.close(this.selectedDate);
  }

  cancel() {
    this.activeModal.dismiss();
  }
  
}
